<template src="@/templates/updateAvailability/updateAvailability.html">
</template>

<script>
    import {mapState, mapActions} from "vuex";
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
    import AvailabilityModel from "@/models/availabilityModel"
    import moment from 'moment'

    export default {
        name: "UpdateAvailability",
        components: {
            VueTimepicker
        },
        computed: {
            ...mapState(["availability", "profile"]),
            statusMessage: function () {
                if (this.interpAvailable) {
                    return "You are available for the time noted below";
                } else {
                    return "Your current status is unavailable";
                }
            }
        },
        data() {
            return {
                isSaving: false,
                availabilityModel: new AvailabilityModel(),
                lastStartTime: '',
                lastEndTime: '',
                lastInterpAvailable: false,
                startTime: '',
                endTime: '',
                interpAvailable: false,
                currentDate: '',
                contact: [],
                numberToCall: '',
                lastAvailableStatus: false,
                disableUIControl: true
            }
        },
        created: function () {
            this.getAvailability();
            this.setCurrentDateTime();
        },
        watch: {
            interpAvailable: function (val) {
              console.log('interpAvailable ==>', val);
                if (val) {
                    // if (this.lastStartTime) {
                    //     if (this.lastAvailableStatus == false) {
                    //         this.disableUIControl = false;
                    //     } else {
                    //         this.disableUIControl = true;
                    //     }
                    // } else {
                    //     this.disableUIControl = false;
                    // }

                    this.disableUIControl = false;
                    this.isSaving = false;
                } else {
                    console.log('disable');
                    this.disableUIControl = true;
                }
            },
        },
        methods: {
            ...mapActions(["updateAvailability"]),
            moment: function () {
                return moment();
            },
            setCurrentDateTime() {
                let currentDateTime = moment();
                this.currentDate = currentDateTime.format('YYYY-MM-DD');
                this.startTime = currentDateTime.format('HH:mm');
                this.endTime = this.startTime;
            },
            getAvailability() {
                let availabilityObj = new AvailabilityModel();
                availabilityObj.fetch(
                    {
                        'url': this.$interpretersApiUrl + this.availabilityModel.getRoute("fetch"),
                        'headers': {'Bearer': localStorage.getItem('jwt')}
                    }
                ).then(res => {
                    let response = res.response.data;
                    if (response.error) {
                        console.error('Error');
                    } else {

                        if (response.contact) {

                            this.contact = response.contact;
                            let mobileInfo = this.contact.filter(m => m.type == 'mobile' && m.value != null);
                            if (mobileInfo.length > 0) {
                                this.numberToCall = mobileInfo[0].value;
                            } else {
                                let phoneInfo = this.contact.filter(m => m.type == 'phone' && m.value != null);
                                if (phoneInfo.length > 0) {
                                    this.numberToCall = phoneInfo[0].value;
                                }
                            }
                        }

                        if (response.from) {
                            this.lastStartTime = moment(response.from).format('HH:mm');
                            this.lastEndTime = moment(response.to).format('HH:mm');
                        }

                        switch (response.available) {
                            case 'yes':
                                this.startTime = moment(response.from).format('HH:mm');
                                this.endTime = moment(response.to).format('HH:mm');
                                this.interpAvailable = true;
                                this.disableUIControl = false;
                                this.lastAvailableStatus = true;
                                break;
                            default:
                                this.setCurrentDateTime();
                                this.interpAvailable = false;
                                this.disableUIControl = true;
                                this.lastAvailableStatus = false;
                                break;
                        }

                        if (response.number_to_call) {
                            this.numberToCall = response.number_to_call;
                        }
                    }
                }).catch((error) => {
                    console.error('error status code');
                    console.log(error.response.response.status);
                    if (error.response) {
                        if (error.response.response.status == '401') {
                            Event.$emit('tokenExpiredLogout');
                            return;
                        }
                    }
                    console.error(error);
                    debugger;
                });
            },
            saveAvailability() {
                this.isSaving=true;
                if (this.lastAvailableStatus) {
                    // if (this.interpAvailable == true) {
                    //     this.showNotification('success', 'Updated Successfully', 'Success True');
                    //     return;
                    // }
                } else {
                    if (this.interpAvailable == false) {
                        this.showNotification('success', 'Updated Successfully', 'Success');
                        this.isSaving=false;
                        return;
                    }
                }


                let startDateTime = this.currentDate + ' ' + this.startTime + ':00';
                let endDateTime = this.currentDate + ' ' + this.endTime + ':00';
                if (startDateTime >= endDateTime) {
                    this.showNotification('warning', 'End Time must be greater than start time!', 'Warning');
                    this.isSaving=false;
                    return;
                }

                if (this.numberToCall == '' || this.numberToCall == null || this.numberToCall == undefined) {
                    this.showNotification('warning', 'Number to call must be supplied', 'Warning');
                    this.isSaving=false;
                    return;
                }


                let availabilityObj = new AvailabilityModel();

                availabilityObj.save(
                    {
                        'url': this.$interpretersApiUrl + this.availabilityModel.getRoute("save"),
                        'data': {
                            "from": startDateTime,
                            "notavail": !this.interpAvailable,
                            "number_to_call": this.numberToCall,
                            "to": endDateTime
                        },
                        'headers': {'Bearer': localStorage.getItem('jwt')}
                    }
                ).then(res => {
                    let response = res.response.data;

                    if (!response) {
                        this.showNotification('danger', 'Unable to update availability!', 'Error');
                        this.isSaving=false;
                        return;
                    }

                    if (response.error) {
                        this.showNotification('danger', 'Unable to update availability!', 'Error');
                        this.isSaving=false;
                        return;
                    }
                    this.showNotification('success', 'Updated Successfully!', 'Success');

                    this.lastStartTime = response.data.from;
                    this.lastEndTime = response.data.to;
                    // this.disableUIControl = true;
                    this.lastAvailableStatus = this.interpAvailable;

                    if (this.interpAvailable == false) {
                        this.setCurrentDateTime();
                    }
                    this.isSaving=false;
                }).catch((error) => {
                    this.isSaving=false;
                    console.log(error)
                    this.showNotification('danger', 'Unable to update availability!', 'Error');
                    debugger;
                });
            },









            closeAvailability() {
                this.updateAvailability(false);
            },
            showNotification(color, text, title = '') {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: color,
                    icon: 'check_box',
                    position: 'top-right'
                });
            }
        }
    }
</script>

<style scoped>
    .vs-popup--content {
        overflow: visible !important;
    }

    .vs-con-input-label {
        width: 100% !important;
    }

    .ftrBtn {
        float: right !important;
    }

    .onoffswitch {
        position: relative;
        width: 142px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }

    .onoffswitch-checkbox {
        display: none;
    }

    .onoffswitch-label {
        display: block;
        overflow: hidden;
        cursor: pointer;
        border: 2px solid #FFFFFF;
        border-radius: 0px;
    }

    .onoffswitch-inner {
        display: block;
        width: 200%;
        margin-left: -100%;
        transition: margin 0.3s ease-in 0s;
    }

    .onoffswitch-inner:before, .onoffswitch-inner:after {
        display: block;
        float: left;
        width: 50%;
        height: 42px;
        padding: 0;
        line-height: 42px;
        font-size: 16px;
        color: white;
        font-family: Trebuchet, Arial, sans-serif;
        font-weight: bold;
        box-sizing: border-box;
    }

    .onoffswitch-inner:before {
        content: "Available";
        padding-left: 14px;
        background-color: #47C93A;
        color: #FFFFFF;
    }

    .onoffswitch-inner:after {
        content: "Unavailable";
        padding-right: 14px;
        background-color: #FF4757;
        color: #FFFFFF;
        text-align: right;
    }

    .onoffswitch-switch {
        display: block;
        width: 17px;
        margin: 14.5px;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 96px;
        border: 2px solid #FFFFFF;
        border-radius: 50px;
        transition: all 0.3s ease-in 0s;
    }

    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }

    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
        right: 0px;
    }

    #statusAvailable {
        color: darkgreen;
    }

    #statusUnavailable {
        color: red;
    }

</style>
